// StoreFront.jsx
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MapPin, Star, Package } from 'lucide-react';
import api from '../utils/api';
import ProductCard from '../components/ProductCard';

export function StoreFront() {
  const { username } = useParams();
  const [store, setStore] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/stores/${username}`).then(r => {
      setStore(r.data.store);
      setProducts(r.data.products || []);
    }).finally(() => setLoading(false));
  }, [username]);

  if (loading) return <div className="flex justify-center items-center min-h-screen"><div className="spinner" /></div>;

  return (
    <div className="min-h-screen pt-20 pb-24">
      <div className="h-32 relative" style={{ background: 'linear-gradient(135deg,#0A0A0F,#1E1E2E)' }}>
        <div className="absolute bottom-0 left-6 translate-y-1/2 w-16 h-16 rounded-2xl overflow-hidden" style={{ border: '3px solid #0A0A0F', background: '#1E1E2E' }}>
          {store?.logoUrl ? <img src={store.logoUrl} alt="" className="w-full h-full object-cover" /> :
            <div className="w-full h-full flex items-center justify-center text-2xl font-bold text-brand-orange" style={{ fontFamily:'Sora' }}>{username?.[0]?.toUpperCase()}</div>}
        </div>
      </div>
      <div className="px-4 pt-12 max-w-6xl mx-auto">
        <h1 className="text-xl font-bold" style={{ fontFamily:'Sora' }}>{store?.name || username}</h1>
        {store?.description && <p className="text-brand-muted text-sm mt-1">{store.description}</p>}
        <div className="flex gap-4 mt-2 text-sm text-brand-muted">
          <span className="flex items-center gap-1"><Star size={13} className="text-yellow-400" />{store?.rating?.toFixed(1) || '0.0'}</span>
          <span className="flex items-center gap-1"><Package size={13} />{products.length} products</span>
        </div>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {products.map(p => <ProductCard key={p._id} product={p} />)}
        </div>
        {products.length === 0 && <div className="text-center py-20 text-brand-muted">No products listed yet</div>}
      </div>
    </div>
  );
}

export default StoreFront;
